import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TreeNode } from 'primeng/api';

import {
    HisAuthService, HisTreeService, HisNotificationService,
    HisUiService, GenericValue, TreeNodeData
} from 'hisng';
import { OrganizationService } from 'app/fs/res/common/service/organization/organization.service';

@Component({
    selector: 'res-internal-organization-edit',
    templateUrl: './internal-organization-edit.component.html',
})
export class InternalOrganizationEditComponent implements OnInit {
    organizations: GenericValue[]; // ngModel
    @Input('organizations') set _organizations(organizations: GenericValue[]) {
        console.log('set organizations =', organizations);
        this.organizations = organizations;
        this.setSelectedTreeElements();
    }
    @Input() isTreeSelectInline: boolean;
    @Input() isAddOrganization: boolean;
    @Input() singleSelect = false;
    @Input() ddKey = 'fs.res.common.organizations.internal';
    @Input() showSelectionBelow = true;
    @Input() personId: number; // optional to put the assigned orgunits of given personId first
    @Input() clearAfterSelection = false;

    @Output() selectedInternalOrgUnitChange: EventEmitter<GenericValue[]> = new EventEmitter();
    @Output() deleteInternalOrgUnitChange: EventEmitter<GenericValue> = new EventEmitter();

    public filteredOptions: GenericValue[];
    public orgunitTree: TreeNode[];
    public selectedTreeElements: any[] = [];
    public selectedOrganization: GenericValue;

    constructor(public auth: HisAuthService,
        public hisUiService: HisUiService,
        private hisTreeService: HisTreeService,
        private notificationService: HisNotificationService,
        private organizationService: OrganizationService) {
    }

    /* Component ngOnInit() */
    ngOnInit() {
        // load orgunit tree
        this.hisTreeService.loadTree('orgunit', 'api/v1/fs/res/orgunitTree').subscribe(
            ( result: TreeNode[] ) => {
                this.orgunitTree = result;
            }
        );
        this.completeMethod({ query: '' });
    }

    /* auto-complete field functions */

    /**
     * completeMethod() implementation of <p-autoComplete> to filter inputs
     *
     * @param event Event contains the autocomplete input field value
     */
    public completeMethod(event: { query: string }) {
        let autocompleteValues: Observable<GenericValue[]>;
        if (typeof this.personId === 'number') {
            autocompleteValues = this.organizationService.getValues(event.query, this.personId);
            autocompleteValues.subscribe( ( organizationsValues: GenericValue[] ) => {
                // organizations are received sorted from the BE
                this.filteredOptions = organizationsValues;
            });
        } else {
            autocompleteValues = this.organizationService.getValues(event.query);
            autocompleteValues.subscribe( ( organizationsValues: GenericValue[] ) => {
                this.filteredOptions = [].slice.call(organizationsValues).sort((a, b) => {
                    if (a.text < b.text) { return -1; }
                    if (a.text > b.text) { return 1; }
                    return 0;
                });
            });
        }
    }

    /**
     * implementation of <p-autoComplete> to add an organization.
     *
     * @param event GenericValue selected value of <p-autoComplete>
     */
    public onSelectByAutocomplete(event: GenericValue) {
        let organizationUnit: GenericValue = event;
        if (this.organizations.find(o => o.id === organizationUnit.id)) {
            this.notificationService.warnI18nRes('fs.res.common.organizations.alreadyAssigned');
            // bei Warnmeldung das input-Feld nicht löschen, damit man noch weiss worum es ging
        } else {
            this.organizations.push(organizationUnit);
            this.setSelectedTreeElements();
            this.selectedInternalOrgUnitChange.emit(this.organizations);
            // Input-Feld löschen
            // #296767 timeout scheint notwendig, damit des Eingabefeld auch bei der 2. und 3. Auswahl wieder gelöscht wird...
            if (this.clearAfterSelection) {
                setTimeout(() => {
                    this.selectedOrganization = null;
                    return;
                });
            }
        }
    }

    /**
     * callback method of <his-tree-select> on change of the selected tree elements.
     *
     * @param event that contains the selected organizations
     */
    public onSelectByTree(event: TreeNodeData[]) {
        console.log('selectedData changed to', event);
        this.organizations = [];
        for (let treeElement of event) {
            if (!(this.organizations.find(o => o.id === treeElement.id))) {
                this.organizations.push(new GenericValue(treeElement.id, treeElement.defaulttext));
            }
        }
        this.setSelectedTreeElements();
        this.selectedInternalOrgUnitChange.emit([...this.organizations]);
    }

    /**
     * delete internal organization from table
     *
     * @param row GenericValue represented as organization to delete from table
     */
    public deleteOrganization(row: GenericValue): void {
        this.setSelectedTreeElements();
        this.deleteInternalOrgUnitChange.emit(row);
    }

    /**
     * set pre-selected option for his-search-select
     */
    private setSelectedTreeElements() {
        this.selectedTreeElements = [];
        if (this.organizations) {
            this.organizations.forEach(o => {
                this.selectedTreeElements.push({ id: o.id, selected: true });
            });
        }
    }

}
